import axios from 'axios';

const baseApi = '/conversations'

class ConversationsService {
      async getConversations(sentBy) {
         const res = await axios.get(`${baseApi}/?sentBy=${sentBy}`)
         return res.data
      }

      async postConversation(data) {
         const res = await  axios.post(`${baseApi}/`, data)
         return res.data
      }

      async updateInteraction(data) {
         const res = await  axios.put(`${baseApi}/`, data)
         return res.data
      }

      async getInteractions(conversationID, refID) {
         const res = await axios.get(`${baseApi}/interactions/?conversationID=${conversationID}&ref=${refID}`)
         return res.data[0]
      }
}

export default new ConversationsService();
